<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                       
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'البنود'" :to="{name: 'items'}">البنود</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="row"> 
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
           
                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i> 
                                        إدارة البنود
                                        </h4>
                                    </div> 
                                     <div class="col-md-6"> 
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item"> <create-button  v-if="hasPermissions('items_create')" :routeName="'items.create'"></create-button></li>
                                        <li class="list-inline-item">
                                          <button class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1
" v-if="searchingMode == 0" @click="searchingMode = 1"> <span>فلاتر البحث</span></button>
                                          <button class="btn btn-danger search-btn-wg mb-2 my-2 " v-if="searchingMode == 1" @click="searchingMode = 0">إغلاق X</button></li>
                                      </ul>
                                                                    
                                      </div>     
      
                                </div>

                            </div>
                            <div class="widget-content widget-content-area">
                                 <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-12 mt-2">
                                          <label for="">نوع البند</label><br>
                                          <input type="radio" v-model="data.searching.is_fees" value="">الكل
                                          <input type="radio" v-model="data.searching.is_fees" value="1">رسوم دراسية
                                            <input type="radio" v-model="data.searching.is_fees" value="0">برامج
                                        </div>
                                        <div class="col-md-4 mt-2">

                            <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>
                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">
                                   <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    
                                    <div class="col-md-12">
                                      <button @click.prevent="printTable" v-if="data.data.length" class="btn btn-success mt-2 mb-2">
                                        <i class="fa fa-print"></i> طباعة
                                      </button>
                                    </div>
                                    <div class="col-md-12" id="print-table">
                                          
                                        <table class="table table-bordered mb-4">
                                            <thead>
                                                <tr>
                                                  <th>
                                                    <a href="#" @click.prevent="resortData();">
                                                      <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                      <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                    </a>
                                                  </th>
                                                    <th @click="resortData();">الاسم</th>
                                                    <th @click="resortData();">الحالة</th>
                                                    <th class="align-center">#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in data.data" :key="index">
                                                    <td>{{index+1}}</td>
                                                    <td>{{item.name}}</td>
                                                    <td>
                                                      <label v-if="item.status == 1" class="badge badge-success">نشط</label>
                                                      <label v-else class="badge badge-danger">غير نشط</label> 
                                                    </td> 
                                                    <td class="text-center">
                                                        
                                                        <div class="dropdown custom-dropdown" v-if="item.is_fees == false">
                                                            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <i class="flaticon-dot-three fs-17"></i>
                                                            </a>
    
                                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                                <edit-button v-if="hasPermissions('groups_edit') && item.is_fees == false" :routing="{name: 'items.edit', params: {id: item.id}}"></edit-button>
                                                              <!-- <a :title="'حذف'" href="javascript:void(0);" class="dropdown-item" v-if="hasPermissions('groups_edit')"
                                                                @click.prevent="sweetAlert('لا يمكنك حذف البيانات حيث انها مرتبطة ببيانات اخرى', 'warning')"><i class="ti-trash"></i> حذف</a> -->
                                                                <delete-button v-if="hasPermissions('groups_delete') && item.is_fees == false" :deleteUrl="'/items/' + item.id" :data="item" @deleteData="deleteData"></delete-button>
                                                            </div>
                                                        </div>

                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>
                                                      <a href="#" @click.prevent="resortData();">
                                                        <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                        <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                      </a>
                                                    </th>
                                                    <th @click="resortData();">الاسم</th>
                                                    <th @click="resortData();">الحالة</th>
                                                    <th class="align-center">#</th>
                                                </tr>
                                            </tfoot>
                                            
                                        </table>
                                    </div>

                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>
                         
                    </div>
                   
                </div>
            </div>


</template>
<script>

export default {
  data() {
    return {
      searchingMode: 0,
      data: {
        data: {},
        searching:{
            id: '',
            is_fees: '',
            perPage: 10,
           sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      }
    };
  },
  created(){
      this.flashAlert();
      this.getIndexData(1);
  },
  methods: {
     resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
      },
      printTable(){
      setTimeout(() => {
        this.print_element('print-table', 'البنود');
      }, 1000);
    },
      getIndexData(page){
        this.$baseApi.get('/items?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data.items;
               this.data.data = response.data.data.items.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
</style>
